import Card, { CardBody } from '../../components/Card';
import { connect } from 'react-redux';
import { getTranslationKey } from '../../modules/utils';
import { SwitchItem } from '../../components';
import { ICollectionsReducerState } from '../../modules/reducers';
import * as actions from '../../actions';
import DesignForm from './Edit/DesignFormNew';
import { TemplatesList } from './TemplatesList';
import { SettingsSection } from '../../components/NewDesign/SettingsSection';
import { SegmentedControl } from '../../components/NewDesign/SegmentedControl';
import { useTemplateConfigurationForm } from './hooks/useTemplateConfigurationForm';
import LayersIcon from '../../assets/img/icons/layers-icon.svg?react';
import GalleryIcon from '../../assets/img/icons/gallery-icon.svg?react';
import GalleryStandardIcon from '../../assets/img/icons/gallery-standart-icon.svg?react';
import GalleryMasonryIcon from '../../assets/img/icons/gallery-masonry-icon.svg?react';
import DotsIcon from '../../assets/img/icons/dots-icon.svg?react';
import styled from 'styled-components';

const FormCard = styled(Card)`
  padding: 0;
`;

const TemplatesSection = styled(SettingsSection)`
  padding-bottom: 20px !important;
`;

type Props = {
  formValue: {
    selectedTemplateId: string;
    design: ICollectionsReducerState['design'];
    galleryStyle: string;
  };
  setValue: (value: Partial<Props['formValue']>, isOnlyColor?: boolean) => void;
  submitColor?: (arg: any) => void;
  availableRules: any;
  setUpgradeAccountOpenState: (obj: any) => void;
};

export const TemplateConfigurationForm = ({
  formValue,
  setValue,
  submitColor,
  availableRules = {},
  setUpgradeAccountOpenState
}: Props) => {
  const {
    selectTemplate,
    setDesign,
    submitDesignColor,
    changeGalleryStyle,
    toggleDecorations,
    toggleTrademark
  } = useTemplateConfigurationForm({
    formValue,
    setValue,
    submitColor,
    availableRules,
    setUpgradeAccountOpenState
  });

  const galleryStyleOptions = [
    {
      value: 'justified',
      label: getTranslationKey('galleryStyleOptions.option1'),
      Icon: GalleryStandardIcon
    },
    {
      value: 'masonry',
      label: getTranslationKey('galleryStyleOptions.option2'),
      Icon: GalleryMasonryIcon
    }
  ];

  return (
    <FormCard className="pt-gallery-preset-design-tab-content">
      <CardBody>
        <TemplatesSection
          icon={LayersIcon}
          title={getTranslationKey('templatesTable')}
          subtitle={getTranslationKey('collectionDesign.templatesHint')}
        >
          <TemplatesList
            newDesign
            values={{ selectedTemplateId: formValue.selectedTemplateId }}
            setValue={({ selectedTemplateId }) => selectTemplate(selectedTemplateId)}
          />
        </TemplatesSection>

        <DesignForm
          templateId={formValue.selectedTemplateId}
          design={{
            disableDecorations: formValue.design.disableDecorations,
            loadFonts: formValue.design.loadFonts,
            imageSpacing: formValue.design.imageSpacing,
            reactionSet: formValue.design.reactionSet,
            iconSet: formValue.design.iconSet,
            newColorPreset: formValue.design.newColorPreset,
            newUseCustomColors: formValue.design.newUseCustomColors,
            variables: {
              ...formValue.design.variables
            },
            newVariables: {
              ...formValue.design.newVariables
            }
          }}
          setDesign={setDesign}
          submitColor={submitDesignColor}
        />

        <SettingsSection icon={GalleryIcon} title={getTranslationKey('galleryStyleOptions.label')}>
          <SegmentedControl
            id="gallery-style"
            value={formValue.galleryStyle}
            onChange={changeGalleryStyle}
            options={galleryStyleOptions}
          />
        </SettingsSection>

        {formValue.selectedTemplateId !== 'ScrAppBook_dark' && (
          <SettingsSection icon={DotsIcon} title={getTranslationKey('collectionDesign.other')}>
            <SwitchItem
              value={!formValue.design.disableDecorations}
              changeCallback={toggleDecorations}
              label={getTranslationKey('collectionDesign.showDecorativeElements')}
              direction="row-reverse"
              id="show-decorative-elements"
              withTooltip
              tooltipText={getTranslationKey('collectionDesign.decorativeElementsTooltipText')}
              isIconTooltip
              margin="0 0 12px 0"
            />
            <SwitchItem
              value={formValue.design.showTrademark}
              changeCallback={toggleTrademark}
              label={getTranslationKey('collectionDesign.photographerMention')}
              direction="row-reverse"
              id="show-photographer-mention"
              withTooltip
              tooltipText={getTranslationKey('collectionDesign.photographerMentionTooltip')}
              isIconTooltip
              margin="0"
            />
          </SettingsSection>
        )}
      </CardBody>
    </FormCard>
  );
};

function mapStateToProps({ accessRules: { availableRules } }: { accessRules: any }) {
  return { availableRules };
}

export default connect(mapStateToProps, actions)(TemplateConfigurationForm);
